import $ from "jquery";
import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RPM } from "../names.js";
const crossRpmMove = ()=>CrossSellingPointer.isActionAvailable(RPM, "move") && window.rml?.hooks.register("attachment/move/finished", (ids, to)=>{
        new CrossSellingPointer($(`.rml-container:visible li[data-li-id="${to}"]`), RPM, "move");
    });
export { crossRpmMove };
